<template>
    <v-container v-if="!libraryCoach" fluid class="pa-0">
        <coach-required />
    </v-container>
    <v-container v-else fluid class="pa-0">

        <div class="library-tabbar">
            <tabs-group :value="currentTab" :tabs="tabs" @change="setCurrentTab" />
        </div>

        <div class="library-content" :key="libraryCoach.id">
            <v-tabs-items v-model="currentTab" class="tabs-items" :touchless="touchless">
                <v-tab-item value="exercises">
                    <exercises-tab @loading="loading = $event" ref="exercises" @touchless="touchless = $event" />
                </v-tab-item>
                <v-tab-item value="prescriptions">
                    <prescriptions-tab @loading="loading = $event" ref="prescriptions" />
                </v-tab-item>
                <v-tab-item value="blocks">
                    <blocks-tab @loading="loading = $event" ref="blocks" />
                </v-tab-item>
                <v-tab-item value="routines">
                    <routines-tab @loading="loading = $event" ref="routines" />
                </v-tab-item>
                <v-tab-item value="programs">
                    <programs-tab @loading="loading = $event" ref="programs" />
                </v-tab-item>
                <v-tab-item value="questionnaires">
                    <questionnaires-tab @loading="loading = $event" ref="questionnaires" />
                </v-tab-item>
                <v-tab-item value="habits">
                    <habits-tab @loading="loading = $event" ref="habits" />
                </v-tab-item>
            </v-tabs-items>
        </div>

    </v-container>
</template>

<script>
import TabsGroup from '@/components/common/TabsGroup';
import RoutinesTab from '@/components/coach/Tabs/RoutinesTab';
import ProgramsTab from '@/components/coach/Tabs/ProgramsTab';
import ExercisesTab from '@/components/coach/Tabs/ExercisesTab';
import BlocksTab from '@/components/coach/Tabs/BlocksTab';
import PrescriptionsTab from '@/components/coach/Tabs/PrescriptionsTab';
import { mapMutations, mapState } from "vuex";
import QuestionnairesTab from '../../components/coach/Tabs/QuestionnairesTab.vue';
import HabitsTab from '../../components/coach/Tabs/HabitsTab.vue';
import CoachRequired from '@/components/company/CoachRequired';

export default {
    components: { TabsGroup, RoutinesTab, ProgramsTab, ExercisesTab, BlocksTab, PrescriptionsTab, QuestionnairesTab, HabitsTab, CoachRequired },
    data() {
        return {
            tabs: [
                { label: this.$t('common.exercises'), value: 'exercises' },
                { label: this.$t('common.prescriptions'), value: 'prescriptions' },
                { label: this.$tc('common.blocks', 2), value: 'blocks' },
                { label: this.$t('common.routines'), value: 'routines' },
                { label: this.$t('common.programs'), value: 'programs' },
                { label: this.$t('common.questionnaires'), value: 'questionnaires' },
                { label: this.$t('habits.title'), value: 'habits', feature: 'habits' },
            ],
            currentTab: 'exercises',
            loading: false,
            touchless: false,
        }
    },
    computed: {
        ...mapState(['libraryTab', 'libraryCoach']),
    },
    async mounted() {
        const vm = this
        if (vm.libraryTab) vm.currentTab = vm.libraryTab
        else vm.setLibraryTab(vm.currentTab)
    },
    methods: {
        ...mapMutations(['setLibraryTab', 'setLibraryFolder', 'setLibraryPage']),
        setCurrentTab(tab) {
            const vm = this;
            vm.currentTab = tab
        },
    },
    watch: {
        currentTab(val, oldVal) {
            if (this.$refs[oldVal]) this.$refs[oldVal].setSearch('')
            if (val !== this.libraryTab) {
                this.setLibraryFolder(null)
                this.setLibraryPage(0)
            }
            this.setLibraryTab(val)
        },
    }
}
</script>

<style scoped>
.library-tabbar {
    margin: -12px -12px 12px;
    padding: 8px 12px 0;
    border-top: 1px solid var(--v-outline-base);
    border-bottom: 1px solid var(--v-outline-base);
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.library-tabbar::-webkit-scrollbar {
    display: none;
}

.tabs-items {
    background-color: transparent;
    padding-bottom: 16px;
}
</style>
